import {ReactNode} from "react"
import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"

interface Props {
  children: ReactNode
  className?: string
}

export default styled.div<Props>`
  background-color: ${({theme}) => theme.colors.greys.lightest};
  color: ${({theme}) => theme.colors.greys.mediumDark};
  border-radius: 5px;
  padding: ${({theme}) => theme.spacing.two};

  ${minWidthMedia.tablet`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  `}
`
